/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import cx from 'classnames';
import scrollIntoView from 'scroll-into-view-if-needed';
import s from './newReturnsTooltip.module.css';
import { toggleTooltip } from '../../actions/tooltip';

const mapStateToProps = ({ tooltip }) => ({
  states: tooltip,
});

const ReturnsTooltipComponent = ({ dispatch, name, content, closeIcon, states }) => {
  const isVisible = states[name];
  const customContent = states.customContent[name];

  const ref = useRef(null);

  useEffect(() => {
    if (isVisible && ref.current) {
      scrollIntoView(ref.current, {
        scrollMode: 'if-needed',
        block: 'center',
        inline: 'center',
      });
    }
  }, [isVisible]);

  if (!isVisible) return null;

  return (
    <div
      id={name}
      ref={ref}
      className={cx(s.tooltip, s.error, s[name], 'error-message', 'error-tooltip')}
    >
      <div
        className={`returns-tooltip-content ${name}`}
        dangerouslySetInnerHTML={{ __html: customContent || content }}
        role="alert"
      />
      <div className="returns-tooltip-custom-content" />
      {closeIcon && (
        <div className={cx('returns-tooltip-close-icon-container', s.close_icon, name)}>
          <i
            className="fa fa-times returns-tooltip-close-icon"
            tabIndex="0"
            aria-label="close"
            role="button"
            onClick={() => {
              dispatch(toggleTooltip(name));
            }}
          />
        </div>
      )}
    </div>
  );
};

ReturnsTooltipComponent.propTypes = {
  dispatch: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  closeIcon: PropTypes.bool.isRequired,
  closeIconOnClick: PropTypes.func,
  states: PropTypes.shape({
    orderNumberTooltip: PropTypes.bool.isRequired,
    invalidProvinceErrorTooltip: PropTypes.bool.isRequired,
    loginErrorTooltip: PropTypes.bool.isRequired,
    step1ErrorTooltip: PropTypes.bool.isRequired,
    returnPostErrorTooltip: PropTypes.bool.isRequired,
  }).isRequired,
};

export const ReturnsTooltip = connect(mapStateToProps)(ReturnsTooltipComponent);
